import './Checkbox.scss';

const Checkbox = ({ checked = false, onChange, children, name, style }) => {
    var classes = ["Checkbox"];
    if (checked) {
        classes.push("Checkbox--checked");
    }
    return (
        <label className={classes.join(" ")} style={style}>
            <input
                name={name}
                type="checkbox"
                checked={checked}
                onChange={onChange}
            />
            <div className="box">
                <svg fill="#000000" width={25} height={25} viewBox="0 0 1920 1920" ><g strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g> <path d="M1827.701 303.065 698.835 1431.801 92.299 825.266 0 917.564 698.835 1616.4 1919.869 395.234z" fillRule="evenodd"></path> </svg>
            </div>
            <div className="Checkbox__text">
                {children}
            </div>
        </label>
    );
};

export default Checkbox;